import {
  DatePicker as _DatePicker,
  DatePickerProps as _DatePickerProps,
} from 'antd'
import { apiDateFormatDayMonthYear } from 'shared/libs/dayjs/model'

import { forwardRef } from 'react'

export type DatePickerProps = _DatePickerProps & {
  timeFormat?: string
  withPlaceholder?: boolean
}
const DatePicker = forwardRef<any, DatePickerProps>(
  (
    {
      timeFormat = apiDateFormatDayMonthYear,
      withPlaceholder = true,
      placeholder,
      ...props
    }: DatePickerProps,
    ref,
  ) => {
    return (
      <_DatePicker
        placeholder={withPlaceholder ? placeholder : ''}
        ref={ref}
        format={{
          format: timeFormat?.toUpperCase(),
          type: 'mask',
        }}
        {...props}
      />
    )
  },
)

export default DatePicker
